import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { COLORS } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(cardContainerMultiColumnStyles, {
    cardDivider: {
        css: css`
            border: 1px solid ${COLORS.border.base};
        `,
    },
});
